export function useFormatters() {

    const formatoCOPManual = (valor) => {

        if (!valor) return "COP 0"

        return new Intl.NumberFormat("es-CO", {
            style: "currency",
            currency: "COP",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(valor)

    }

    const formatoCOP = (valor) => {

        const numero = Number(
            String(valor)
                .replace(/[^\d]/g, "")
        )

        if (!numero || isNaN(numero)) {
            return "COP 0"
        }

        return new Intl.NumberFormat("es-CO", {
            style: "currency",
            currency: "COP",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        })
            .format(numero)
            .replace("$", "COP ")

    }

    // 🔥 IMPORTANTE
    return {

        formatoCOPManual,

        formatoCOP

    }

}